import React, { forwardRef, useImperativeHandle, useRef } from "react";

// TODO(future): Uploaded image gallery, thumbnail reuse, CloudFront image browser.
const EmailImageInsertMenu = forwardRef(({
  onInsertImage,
  imageUploadHandler,
  onError,
}, ref) => {
  const fileInputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    openMenu: () => {
      fileInputRef.current?.click();
    },
  }));

  const handleFileSelected = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    try {
      const url = await imageUploadHandler(file);
      if (url && typeof onInsertImage === "function") {
        onInsertImage(url, file.name || "Image");
      }
    } catch (err) {
      if (typeof onError === "function") {
        onError(err?.message || "Failed to upload image");
      }
    }
  };

  return (
    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      hidden
      onChange={handleFileSelected}
    />
  );
});

EmailImageInsertMenu.displayName = "EmailImageInsertMenu";

export default EmailImageInsertMenu;
